import { QUOTE_TYPES } from '@app-types/cart';
import { SimulatedCartProduct } from '@app-types/product';

export function getSimulatedPhone(
    simulatedCart?: SimulatedCartProduct,
    phoneGencode?: string,
    quoteType = QUOTE_TYPES.ACQUISITION,
) {
    return simulatedCart?.quotes?.find((q) => q.type === quoteType)?.products.find((el) => el.gencode === phoneGencode);
}
